$(window).on('load', function() {
	if ($window.width() < breakpoint) {
		initMobileTeam();
	}
    initResizeWatcher();
})

let
	$window = $(window),
	breakpoint = 992,
	prevWidth;

function initResizeWatcher() {
	console.log('initResizeWatcher()');

    $window.on('resize', function() {
        if ($window.width() >= breakpoint) {
			// Mobile to desktop.
			if (prevWidth < breakpoint) {
				// console.log('mobile to desktop');
				exitMobileTeam();
			}
		} else {
			// Desktop to mobile.
			if (prevWidth >= breakpoint) {
				// console.log('desktop to mobile');
				initMobileTeam();
			}
		}
		prevWidth = $window.width();
    });
}

function initMobileTeam()  {
	console.log('initMobileTeam()');
	var $chips = $('.team-chip');

	$chips.on('click', function() {
		console.log('CLICK');
		// Lock page scroll.
		$('html').css('overflow', 'hidden');
		$('body').css('overflow', 'hidden');
		// $('body').css('padding-right', '8px');
		// $('html').css('padding-right', '7px');

		// Display alt chip content.
		var $my_alt_chip = $(this).find('.team-chip__alt');
		var my_markup 	=  '<div class="section-page-team__overlay" style="">';
		my_markup		+= '	<div class="overlay__bg" style="top:100%;">';
		my_markup		+= '		<div class="container">';
		my_markup		+= '			<div class="overlay__btn"></div>';
		my_markup		+= '		</div>';
		my_markup		+= '	</div>';
		my_markup		+= '</div>';
		$('body').append(my_markup);
		$('.overlay__bg .container').prepend($my_alt_chip.clone());
		setTimeout(() => {
			$('.overlay__bg').css('opacity','1');
			$('.overlay__bg').css('top','10%');
		}, 100);

		// Close button code.
		$('.section-page-team__overlay').on('click', function() {
			closePop();
		});
	});
}

function exitMobileTeam()  {
	console.log('exitMobileTeam()');
	var $chips = $('.team-chip');
	var $overlay = $('.section-page-team__overlay');

	// If .section-page-team__overlay exists, remove and restore page scroll.
	if ($overlay.length) {
		// Remove.
		$overlay.remove();
		// Unlock page scroll.
		// $('html').css('overflow-x', 'hidden');
		// $('html').css('overflow-y', 'scroll');
		// $('body').css('overflow-x', 'hidden');
		// $('body').css('overflow-y', 'scroll');
		$('html').css('overflow', 'auto');
		$('body').css('overflow', 'auto');	
		// $('html').css('padding-right', '0');
	}

	// Remove mobile chip click code.
	$chips.off('click')
}

function closePop() {
	console.log('closePop()');
	// Remove alt chip content.
	// $('.overlay__bg').hide( {
	// 	complete: function() {
	// 		$('.section-page-team__overlay').remove();
	// 	}
	// });
	// $('.overlay__bg').hide(300);
	// $('.overlay__bg').css('top','100%');
	$('.overlay__bg').css('opacity','0');
	setTimeout(() => {
		$('.section-page-team__overlay').remove();
	}, 300);

	// Unlock page scroll.
	// $('html').css('overflow-x', 'hidden');
	// $('html').css('overflow-y', 'scroll');
	// $('body').css('overflow-x', 'hidden');
	// $('body').css('overflow-y', 'scroll');
	$('html').css('overflow', 'auto');
	$('body').css('overflow', 'auto');
	// $('html').css('padding-right', '0');
}